import { Interactivity } from "./types";

export const noInteractivity: Interactivity = {
  isSelected: () => false,
  isHovered: () => false,
  isDayHovered: () => false,
  isTimeHovered: () => false,
  interactivityCallbacks: () => ({
    onTouchStart: () => {},
    onMouseEnter: () => {},
    onMouseDown: () => {},
    onMouseOver: () => {},
    onMouseUp: () => {},
    onMouseLeave: () => {},
  }),
}

export function useNoInteractivity(): Interactivity {
  return noInteractivity;
}